const a = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true"><path d="M13.78 5.47a.75.75 0 1 0-1.06 1.06L18.19 12l-5.47 5.47a.75.75 0 1 0 1.06 1.06l6-6a.75.75 0 0 0 0-1.06zm-8 0a.75.75 0 0 0-1.06 1.06L10.19 12l-5.47 5.47a.75.75 0 1 0 1.06 1.06l6-6a.75.75 0 0 0 0-1.06z"/></svg>';
export {
  a as w
};
